import { gender } from "../residents";
import { SortDirection } from "../types";

export interface UsersFilterMap {
  [key: string]: boolean;
}

export type AppsStateUsersState = {
  users: UsersData;
  isLoading: boolean;
  inviteRequestSucceed: boolean;
  isEditRequestSuccess: boolean;
  mobileDeviceUser: MobileDeviceUserData;
  isLoadingMobileDeviceUser: boolean;
  settings: {
    searchValue: string;
    filters: UsersFilterMap;
    sort: UsersSort;
    selectedUsers: string[];
  };
};
export type UsersSort = {
  type: UsersSortType;
  direction: SortDirection;
};
export enum UsersSortType {
  Name = "Name",
  Email = "EMail",
  Block = "Block",
  LastActivity = "LastActivity",
}

export type UsersData = {
  [key: string]: UsersProfile;
};

export type MobileDeviceUserData = {
  [key: string]: MobileDeviceUser;
};

export type SelectedUsers = {
  [key: string]: boolean;
};
export enum ProviderType {
  IN_SYSTEM = "auth0",
  GOOGLE = "google-oauth2",
  MICROSOFT = "windowslive",
  SMS = "sms",
}
export const provider = (pr: ProviderType[]): string => {
  const type = pr[0];
  return type === ProviderType.IN_SYSTEM
    ? "In-system"
    : type === ProviderType.GOOGLE
    ? "Google"
    : type === ProviderType.SMS
    ? "SMS"
    : "Microsoft";
};

export type InviteUsersDTO = {
  nodeId: string | number;
  roleName: RoleType;
  usernames: string[];
};
export type ResendEmailsDTO = { userId: string };
export type GetUsersDTO = {
  includeRole: boolean;
  includeActivityStatus: boolean;
  page?: number;
  items?: number;
};

export enum UserActivityStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum RoleType {
  OWNER = "Owner",
  ADMIN = "Admin",
  VIEWER = "Viewer",
  DEV = "Dev",
  API_USER = "APIUser",
  CAREGIVER = "Caregiver",
  DISPLAY = "DisplayUser",
}

export enum StatusType {
  ACTIVE = "active",
  PENDING = "pending",
  SUSPENDED = "suspended",
}

export enum AccessLevelType {
  ORGANIZATION = "organization",
  BLOCK = "block",
}

export enum UserDevice {
  NO_DEVICE = "noDevice",
  OFFLINE = "Offline",
  ONLINE = "Online",
}

export enum UserMobileDevice {
  NO_DEVICE = "mobilenoDevice",
  OFFLINE = "mobileOffline",
  ONLINE = "mobileOnline",
}
export type UsersProfile = {
  id: string | undefined;
  picture: string | undefined;
  roleName: RoleType | undefined;
  email: string | undefined;
  baseNodeId: number | undefined;
  profileCompleted: boolean | undefined;
  providers: ProviderType[];
  status: StatusType | undefined;
  language: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  gender: gender | undefined;
  dateOfBirth: string | undefined;
  activityStatus: UserActivityStatus;
  activityStatusUpdatedOn: string | undefined;
  deviceId?: string;
};

export type EditUserInfoRequest = {
  id: string;
  firstName: string;
  lastName: string;
  currentBaseNodeId: number;
  newBaseNodeId: number | null;
  roleName: RoleType;
};

export type UsersSettings = {
  searchValue?: string;
  sort?: UsersSort;
  filters?: UsersFilterMap;
  selectedUsers?: string[];
};

export type UserPermissionAndStatus = {
  firstName: string;
  lastName: string;
  id: string;
  currentBaseNodeId: string | number;
  newBaseNodeId: string | number;
  roleName: RoleType;
};

export type UserStatusDTO = {
  nodeId: number;
  status: StatusType;
  userId: string;
};

export type UserIdDTO = {
  id: string;
  nodeId: number;
};

export type UserProfileSocket = {
  firstName: string;
  lastName: string;
  nodeId: number;
  status: StatusType;
  userId: string;
};

export type UserActivitySocket = {
  userId: string;
  updatedOn: string;
  status: UserActivityStatus;
};
// export type UserStatusDto = {
//     UserId: string;
// };

export const EMPTY_USER: UsersProfile = {
  id: "",
  picture: "",
  roleName: undefined,
  email: "",
  baseNodeId: undefined,
  profileCompleted: undefined,
  providers: [],
  status: undefined,
  language: undefined,
  firstName: "N",
  lastName: "A",
  gender: undefined,
  dateOfBirth: undefined,
  activityStatus: null,
  activityStatusUpdatedOn: undefined,
};

export type DeviceUserDTO = {
  deviceId: string;
  id: string;
  nodeId: string;
  deviceType?: TagTypes;
};

export type MobileDeviceUser = {
  userId: string;
  userConfigurations: UserMobileDeviceConfigurations[];
  devices: OneUserDevice[];
};

export type OneUserDevice = {
  deviceId: string;
  serialNumber: string;
  deviceType: TagTypes;
  status: boolean;
  metadata: string;
  configurations: any[];
  continuesDetectionTime: number;
};
export type UserMobileDeviceConfigurations = {
  configName: "MobileTag";
  configValue: { Enable: boolean };
};

export enum TagTypes {
  Android = "Android",
  Web = "Web",
  Tag = "Tag",
  iOS = "iOS",
  Watch = "Watch",
}
export type UserMobileDeviceConfigurationsDTO =
  UserMobileDeviceConfigurations & {
    userId: string;
  };

export const CONTINUOUS_DETECTION_TIME_DEFAULT = 30;
